"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _themeUi = require("theme-ui");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContentSlider = function ContentSlider(_ref) {
  var children = _ref.children,
      currentIndex = _ref.currentIndex,
      applyFadeEffect = _ref.applyFadeEffect,
      animationResizeDuration = _ref.animationResizeDuration,
      animationFadeDuration = _ref.animationFadeDuration,
      animationSlideDuration = _ref.animationSlideDuration,
      unmountWhenHidden = _ref.unmountWhenHidden,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "currentIndex", "applyFadeEffect", "animationResizeDuration", "animationFadeDuration", "animationSlideDuration", "unmountWhenHidden"]);

  var _useState = (0, _react.useState)('auto'),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isAnimating = _useState2[0],
      setIsAnimating = _useState2[1];

  var _useState3 = (0, _react.useState)(currentIndex),
      previousIndex = _useState3[0],
      setPreviousIndex = _useState3[1];

  var _useState4 = (0, _react.useState)(currentIndex),
      transitionToIndex = _useState4[0],
      setTransitionToIndex = _useState4[1];

  var animationEndTimeout = (0, _react.useRef)();
  var trackRef = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    var endAnimation = function endAnimation() {
      setPreviousIndex(currentIndex);
      setHeight('auto');
      setIsAnimating(false);
    };

    var updateCaroselHeight = function updateCaroselHeight() {
      var currentCaroselItem = trackRef.current.children[currentIndex].children[0];
      var transitionedCaroselItem = trackRef.current.children[previousIndex].children[0];
      requestAnimationFrame(function () {
        setHeight(transitionedCaroselItem.scrollHeight + "px");
        requestAnimationFrame(function () {
          setHeight(currentCaroselItem.scrollHeight + "px");
          animationEndTimeout.current = setTimeout(endAnimation, animationResizeDuration);
        });
      });
    };

    if (!isAnimating && previousIndex !== currentIndex) {
      clearTimeout(animationEndTimeout.current);
      setTransitionToIndex(currentIndex);
      setIsAnimating(true);
      updateCaroselHeight();
    }
  }, [isAnimating, currentIndex, height, previousIndex, animationResizeDuration, animationEndTimeout]);
  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(animationEndTimeout.current);
    };
  }, []);

  var isBetween = function isBetween(n, a, b) {
    return (n - a) * (n - b) <= 0;
  };

  var findItemPosition = function findItemPosition(index) {
    return (index - transitionToIndex) * 100 + "%";
  };

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      overflow: unmountWhenHidden && !isAnimating ? 'visible' : 'hidden',
      width: '100%',
      height: height,
      position: 'relative',
      transition: "height " + animationResizeDuration + "ms"
    },
    ref: trackRef
  }), _react["default"].Children.map(children, function (item, index) {
    return (0, _themeUi.jsx)("div", {
      sx: {
        position: 'relative',
        width: '100%',
        transition: "opacity " + animationFadeDuration + "ms",
        opacity: applyFadeEffect && transitionToIndex !== index ? 0 : 1
      }
    }, (0, _themeUi.jsx)("div", {
      sx: {
        overflow: 'hidden',
        position: !isAnimating && transitionToIndex === index ? 'static' : 'absolute',
        width: '100%',
        transition: "transform " + animationSlideDuration + "ms cubic-bezier(0.21, 0.61, 0.15, 1)",
        transform: !isAnimating && transitionToIndex === index ? 'translateX(0)' : "translateX(" + findItemPosition(index) + ")"
      },
      index: index
    }, (!unmountWhenHidden || !applyFadeEffect && isBetween(index, previousIndex, transitionToIndex) || applyFadeEffect && (index === previousIndex || index === transitionToIndex)) && (0, _themeUi.jsx)(_react.Fragment, null, item)));
  }));
};

ContentSlider.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),
  currentIndex: _propTypes["default"].number,
  applyFadeEffect: _propTypes["default"].bool,
  animationSlideDuration: _propTypes["default"].number,
  animationFadeDuration: _propTypes["default"].number,
  animationResizeDuration: _propTypes["default"].number,
  unmountWhenHidden: _propTypes["default"].bool
};
ContentSlider.defaultProps = {
  children: null,
  currentIndex: 0,
  applyFadeEffect: true,
  animationSlideDuration: 500,
  animationFadeDuration: 400,
  animationResizeDuration: 400,
  unmountWhenHidden: true
};
var _default = ContentSlider;
exports["default"] = _default;